import React, { useContext } from "react";
import { Button } from "@web-monorepo/mds";
import { IconTranslateTwo, IconChevronDown } from "@src/dds-icons";
import { ModalContext, ModalType } from "@src/components/modals/ModalController";
import { TranslationContext } from "@src/components/translation/TranslationContext";
import { localesList } from "@src/utils/localesList";
import { fixLocale } from "@src/utils/routes";
import { logEvent } from "@src/utils/logClient";

export const FooterLanguageTrigger: React.FC = () => {
  const { translationLocaleAsString } = useContext(TranslationContext);
  const modalContext = useContext(ModalContext);

  const currentLocale = fixLocale(translationLocaleAsString?.() || "en-us");
  const currentLanguageName = localesList[currentLocale] || "English";

  const handleClick = () => {
    logEvent({
      eventName: "web.external_page.footer.language_picker.click",
    });
    modalContext.showModal(ModalType.LanguageChooser);
  };

  return (
    <Button variant="secondary" size="s" icon={<IconChevronDown />} onClick={handleClick}>
      <span className="flex items-center gap-x-xs flex-1">
        <IconTranslateTwo className="w-16 h-16" />
        <span>{currentLanguageName}</span>
      </span>
    </Button>
  );
};
